
import { ModuleRegistry, ClientSideRowModelModule } from 'ag-grid-community';
import { Component } from '@angular/core';
import { ExportStateService } from './service/export-state.service';
ModuleRegistry.registerModules([ClientSideRowModelModule]);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'lios-export-mfe';
  isAuthorized: boolean = false;
  AUthToken: boolean = false;
  clientHeight: number;
  constructor(private  readonly state: ExportStateService) {
    this.clientHeight = window.innerHeight;
  }

  ngOnInit() {

    if (localStorage.getItem('toyotaGUID')) {
      this.AUthToken = true;
    }

    
    this.state.roleState.subscribe((value) => {
      if (value) {
        this.isAuthorized = true;
      }
    });
  }


}

